import type { introspection } from "@/graphql-env";

type CompanyWorkDays = introspection["types"]["CompanyWorkDays"]["enumValues"];

const ALL_WEEKDAY_INDICES = [0, 1, 2, 3, 4, 5, 6];

const WEEKDAY_INDICES_BY_COMPANY_WORK_DAYS: Record<CompanyWorkDays, number[]> =
  {
    WORK_ALL_DAYS: ALL_WEEKDAY_INDICES,
    NO_WORK_ON_SATURDAY: [0, 1, 2, 3, 4, 5],
    NO_WORK_ON_SUNDAY: [1, 2, 3, 4, 5, 6],
    NO_WORK_WEEKEND: [1, 2, 3, 4, 5],
  };

/**
 * Maps the API's `CompanyWorkDays` enum (weekend-only variations) to weekday
 * indices (`0 = Sunday … 6 = Saturday`), the convention already used by the
 * calendar grid and capacity calculations. Falls back to all 7 days for any
 * value it doesn't recognize, so a future enum member the frontend hasn't
 * caught up to never causes real workdays to be hidden or undercounted.
 */
export function mapCompanyWorkDaysToWeekdayIndices(
  companyWorkDays: CompanyWorkDays,
): number[] {
  return (
    WEEKDAY_INDICES_BY_COMPANY_WORK_DAYS[companyWorkDays] ?? ALL_WEEKDAY_INDICES
  );
}
